module.exports = __webpack_public_path__ + "img/2d.e6e38df7.png";